
import {Component, Mixins, Watch} from 'vue-property-decorator';
import {authentication, permission} from "@pazion/pazion-core/src/store";
import PermissionService from "@pazion/pazion-core/src/services/permission-service";

@Component({})
export default class Home extends Mixins(PermissionService) {
  get isLoggedIn() {
    return authentication.isUserLoggedIn;
  }

  async mounted() {
    if (this.$router.currentRoute.name != permission.getHomeRoute) {
      await this.$router.push({name: permission.getHomeRoute});
      return;
    }
  }


  @Watch('isLoggedIn')
  listenToLogin(newVal: boolean, oldval: boolean) {
    if (!newVal) {
      this.$router.push({name: 'login'});
    }
  }

}
